"use client";

export default function HouseRules() {
    return (
        <div className="w-full px-4 md:px-6 py-10 md:py-15 bg-green-900 rounded-3xl">
            <h2 className="font-bold text-3xl sm:text-4xl md:text-5xl text-center mb-8 md:mb-12">
                House Rules & Policies
            </h2>

            <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
                {/* Check-in/Check-out */}
                <div className="space-y-4">
                    <h3 className="font-bold text-xl md:text-2xl border-b-2 border-white pb-2">
                        Check-in & Check-out
                    </h3>
                    <ul className="space-y-2 text-base md:text-lg">
                        <li>• <strong>Check-in:</strong> 4:00 PM</li>
                        <li>• <strong>Check-out:</strong> 11:00 AM</li>
                        <li>• Early check-in/late check-out upon request</li>
                        <li>• Self check-in with lockbox</li>
                        <li>• We&apos;ll send detailed instructions before arrival</li>
                    </ul>
                </div>

                {/* Guest Policies */}
                <div className="space-y-4">
                    <h3 className="font-bold text-xl md:text-2xl border-b-2 border-white pb-2">
                        Guest Policies
                    </h3>
                    <ul className="space-y-2 text-base md:text-lg">
                        <li>• Maximum occupancy: 12 guests</li>
                        <li>• Additional guests: $50/person/night</li>
                        <li>• All guests must be registered at booking</li>
                        <li>• Suitable for children (supervised)</li>
                        <li>• Infants and children under 2 don&apos;t count toward limit</li>
                    </ul>
                </div>

                {/* House Rules */}
                <div className="space-y-4">
                    <h3 className="font-bold text-xl md:text-2xl border-b-2 border-white pb-2">
                        House Rules
                    </h3>
                    <ul className="space-y-2 text-base md:text-lg">
                        <li>• <strong>No smoking</strong> inside the cabin</li>
                        <li>• <strong>No parties or events</strong></li>
                        <li>• Quiet hours: 10 PM - 8 AM</li>
                        <li>• Respect the neighbors and property</li>
                        <li>• Please clean up after yourself</li>
                        <li>• Report any damages immediately</li>
                    </ul>
                </div>

                {/* Pet Policy */}
                <div className="space-y-4">
                    <h3 className="font-bold text-xl md:text-2xl border-b-2 border-white pb-2">
                        Pet Policy
                    </h3>
                    <ul className="space-y-2 text-base md:text-lg">
                        <li>• Pets welcome! (up to 2 pets)</li>
                        <li>• Pet fee: $75 per pet</li>
                        <li>• Must be house-trained and well-behaved</li>
                        <li>• No pets left alone in the cabin</li>
                        <li>• Clean up after your pets outside</li>
                        <li>• Keep pets off furniture and beds</li>
                    </ul>
                </div>

                {/* Safety & Security */}
                <div className="space-y-4">
                    <h3 className="font-bold text-xl md:text-2xl border-b-2 border-white pb-2">
                        Safety & Security
                    </h3>
                    <ul className="space-y-2 text-base md:text-lg">
                        <li>• Smoke and CO detectors installed</li>
                        <li>• Fire extinguishers available</li>
                        <li>• First aid kit provided</li>
                        <li>• Fire pit use: supervised only</li>
                        <li>• Emergency numbers posted</li>
                        <li>• Exterior security cameras (parking area only)</li>
                    </ul>
                </div>

                {/* Cancellation Policy */}
                <div className="space-y-4">
                    <h3 className="font-bold text-xl md:text-2xl border-b-2 border-white pb-2">
                        Cancellation Policy
                    </h3>
                    <ul className="space-y-2 text-base md:text-lg">
                        <li>• Free cancellation: 14+ days before check-in</li>
                        <li>• 50% refund: 7-14 days before check-in</li>
                        <li>• No refund: Less than 7 days before check-in</li>
                        <li>• Security deposit: $500 (refundable)</li>
                        <li>• Deposit returned within 7 days after checkout</li>
                    </ul>
                </div>
            </div>

            {/* Additional Information */}
            <div className="max-w-5xl mx-auto mt-10 p-6 bg-green-950 rounded-xl">
                <h3 className="font-bold text-xl md:text-2xl mb-4">Additional Information</h3>
                <div className="space-y-3 text-base md:text-lg">
                    <p>
                        <strong>Minimum Stay:</strong> 2 nights on regular dates, 3 nights on holiday weekends
                    </p>
                    <p>
                        <strong>Cleaning:</strong> $100 cleaning fee (one-time). Please wash dishes and take out trash before checkout
                    </p>
                    <p>
                        <strong>Parking:</strong> Space for 4+ vehicles. No RVs or trailers please
                    </p>
                    <p>
                        <strong>WiFi:</strong> High-speed internet provided. Password will be shared after booking
                    </p>
                </div>
            </div>
        </div>
    );
}
